<template>
    <b-modal
        id="modal-confirmdetail"
        size="xl"
        ref="modal"
        :title="formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="warning"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <b-tabs card>
                <b-tab
                    :title="
                        $t('prod_treatment', {
                            ns: 'production'
                        })
                    "
                    v-bind:key="1"
                    active
                >
                    <b-card-text>
                        <div>
                            <b-row>
                                <b-col sm="6">
                                    <b-input-group
                                        :prepend="
                                            $t('prod_action', {
                                                ns: 'production'
                                            })
                                        "
                                    >
                                        <b-form-input
                                            v-model="behandeling"
                                            readonly
                                        ></b-form-input>
                                    </b-input-group>
                                    <b-input-group
                                        :prepend="
                                            $t('prod_uitgevoerd', {
                                                ns: 'production'
                                            })
                                        "
                                        class="form-inline"
                                    >
                                        <b-input-group v-if="!useTimeInput">
                                            <b-form-timepicker
                                                v-model="uitvoerTijdstip"
                                                @input="set_changed"
                                                :disabled="!editAllowed"
                                            ></b-form-timepicker>
                                        </b-input-group>
                                        <b-input-group v-if="useTimeInput">
                                            <b-form-input
                                                v-model="localDate"
                                                :type="'date'"
                                                @blur="setDatumtijd"
                                                :disabled="!editAllowed"
                                                :class="giveBGclass"
                                            ></b-form-input>
                                            <b-form-input
                                                v-model="localTijd"
                                                :type="'time'"
                                                @blur="setDatumtijd"
                                                :disabled="!editAllowed"
                                                :class="giveBGclass"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-input-group>
                                    <div v-if="needsCoatingProduct">
                                        <div v-if="baseTAC.coatingproduct">
                                            <b-input-group
                                                :prepend="
                                                    $t('prod_coating', {
                                                        ns: 'production'
                                                    })
                                                "
                                            >
                                                <b-form-select
                                                    key="rerenderkey"
                                                    v-model="partijID"
                                                    @change="set_inputPartij"
                                                    :disabled="!editAllowed"
                                                    v-bind:class="{
                                                        tc_aux_highlighted:
                                                            warnForStockAmount
                                                    }"
                                                >
                                                    <template #first>
                                                        <b-form-select-option
                                                            value=""
                                                            >--
                                                            {{
                                                                $t(
                                                                    'com_selecteer',
                                                                    {
                                                                        ns: 'common'
                                                                    }
                                                                )
                                                            }}
                                                            --</b-form-select-option
                                                        >
                                                    </template>
                                                    <option
                                                        v-for="option in itemStockList"
                                                        :value="option.value"
                                                        :key="option.value"
                                                        v-bind:class="{
                                                            tc_aux_highlighted:
                                                                option.warn
                                                        }"
                                                    >
                                                        {{ option.text }}
                                                    </option>
                                                </b-form-select>
                                            </b-input-group>
                                        </div>
                                        <div v-else>
                                            <b>{{ strNoCoating }}</b>
                                        </div>
                                    </div>
                                    <b-input-group
                                        :prepend="
                                            $t('prod_tolocation', {
                                                ns: 'production'
                                            })
                                        "
                                        class="form-inline"
                                    >
                                        <lookup-combo
                                            v-model="
                                                refreshedTreatment.naarLocatieID
                                            "
                                            v-bind:combotype="lctypeLocation"
                                            v-bind:discrim="null"
                                            :disabled="!editAllowed"
                                        ></lookup-combo>
                                        <b-form-input
                                            v-model="
                                                refreshedTreatment.naarLocatieText
                                            "
                                        ></b-form-input>
                                    </b-input-group>
                                    <b-form-textarea
                                        id="bakopmerking"
                                        v-model="refreshedTreatment.opmerking"
                                        :placeholder="
                                            $t('com_opmerking', {
                                                ns: 'common'
                                            })
                                        "
                                        rows="3"
                                        max-rows="6"
                                        @change="set_changed"
                                    ></b-form-textarea>
                                </b-col>
                                <b-col sm="6">
                                    <show-row-col
                                        :showLabel="
                                            $t('com_kaassoort', {
                                                ns: 'common'
                                            })
                                        "
                                        :showObject="baseTAC.product"
                                    />
                                    <show-row-col
                                        :showLabel="
                                            $t('com_number', {
                                                ns: 'common'
                                            })
                                        "
                                        :showObject="baseTAC.startaantal"
                                    />
                                    <show-row-col
                                        :showLabel="
                                            $t('com_location', {
                                                ns: 'common'
                                            })
                                        "
                                        :showObject="baseTAC.locatie"
                                    />
                                    <show-row-col
                                        :showLabel="
                                            $t('prod_gepland', {
                                                ns: 'production'
                                            })
                                        "
                                        :showObject="planned"
                                    />
                                    <hr />
                                    <b-row class="mx-0 px-0 my-0 py-0">
                                        <b-table
                                            :items="marksList"
                                            :fields="visibleMarksFields"
                                            stacked="md"
                                            show-empty
                                            :empty-text="
                                                $t('com_geen_data', {
                                                    ns: 'common'
                                                })
                                            "
                                            small
                                            striped
                                            responsive
                                        >
                                            <template #cell(startmerk)="data">
                                                {{ data.item.startcharacters }}
                                                &nbsp;
                                                {{ data.item.startnumber }}
                                            </template>
                                            <template #cell(eindmerk)="data">
                                                {{ data.item.endcharacters }}
                                                &nbsp;
                                                {{ data.item.endnumber }}
                                            </template>
                                        </b-table>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="canTransform">
                            <stock-transform
                                :inStock="transStock"
                                @input="setTransfomation"
                            />
                        </div>
                    </b-card-text>
                </b-tab>
                <activity-log
                    paramName="measurementID"
                    action="treatment/loadTreatmentActiviteitenLijst"
                    :id="treatmentActivityId"
                />
            </b-tabs>
        </b-card>
    </b-modal>
</template>

<script lang="ts">
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { defineComponent } from 'vue';
import { VueExtension } from '../../models/VueExtension';
import { loadList, loadItem } from '../../models/DataHelper';
import { TreatmentActivity } from '@/models/CheeseTreatment';
import { VoorraadItem } from '@/models/Voorraad';
import { ShowRowCol, ActivityLog } from '../components';
import StockTransform from '../stock/StockTransform.vue';
import { LookupCombo } from '../components/index';
import { Feature } from '../../models/Features';

export default defineComponent({
    name: 'ConfirmTreatmentModal',
    data: function () {
        return {
            lctypeLocation: window.constants.LCLOCATION,
            transformTypeVersnijden: 11,
            transformTypeVerpakken: 12,
            showDismissibleAlert: false,
            coatingProductAsked: false,
            transformAsked: false,
            alertText: '',
            flexList: [] as Array<VoorraadItem>,
            refreshedTreatment: {} as TreatmentActivity,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            refreshedMarks: {} as any | null,
            currentBak: null,
            currentProdRecept: null,
            bakID: -1,
            aangeraakt_teller: 1,
            localChanged: true,
            showBakDetails: false,
            editAllowed: true,
            warnAmount: false,
            forceRefresh: false,
            canTransform: false,
            transformType: 0,
            needsCoatingProduct: false,
            transStock: {} as VoorraadItem,
            uitvoerTijdstip: DateHelper.convertedToTime(new Date()),
            localDate: null,
            localTijd: null,
            partijID: -1,
            prevPartijID: -1,
            maxDelay: 12,
            rerenderkey: 1,
            strStockEmpty: this.$t('com_stockempty', { ns: 'common' }),
            strOpschuiven: this.$t('prod_warntreatmentnotintime', {
                ns: 'production'
            }),
            strNoCoating: this.$t('prod_warnnocoating', {
                ns: 'production'
            }),
            strSaveWithoutProduct: this.$t('prod_warnnocoatingproduct', {
                ns: 'production'
            }),
            strNoTransform: this.$t('prod_warnnotransform', {
                ns: 'production'
            }),
            strNoTransformCut: this.$t('prod_meerdanval', {
                ns: 'production',
                item: this.$t('com_transformfactor', { ns: 'common' }),
                val: 1
            }),
            strNoTransformPack: this.$t('prod_minderdanval', {
                ns: 'production',
                item: this.$t('com_transformfactor', { ns: 'common' }),
                val: 1
            })
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        treatmentActivityId: {
            type: Number,
            required: true
        },
        treatmentActivity: {
            type: TreatmentActivity,
            required: true
        },
        behandeling: {
            type: String,
            required: true
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ShowRowCol,
        StockTransform,
        ActivityLog,
        LookupCombo
    },
    watch: {},
    computed: {
        formtitle() {
            return (
                this.$t('com_detail', { ns: 'common' }) +
                ' ' +
                this.$t('prod_treatment', { ns: 'production' }).toLowerCase()
            );
        },
        baseTAC() {
            return this.treatmentActivity;
        },
        marksList() {
            return this.refreshedMarks != undefined
                ? this.refreshedMarks.data != undefined
                    ? this.refreshedMarks.data.Items
                    : []
                : [];
        },
        warnForStockAmount() {
            return this.warnAmount;
        },
        planned() {
            return DateHelper.convertedToDate(this.baseTAC.starttijdplan, true);
        },
        needsCoatingProductObsolete() {
            return (
                this.refreshedTreatment.behandelstapID ==
                    window.constants.COATING_STEPID ||
                this.refreshedTreatment.behandelstapID >
                    window.constants.START_SEQ
            );
        },
        itemStockList() {
            const tempList = this.flexList.map((x) => {
                const tekst = x.datum
                    ? Helper.stringformat(
                          '{0} (' +
                              this.$t('com_tht', { ns: 'common' }) +
                              ': {1})',
                          x.batchID,
                          DateHelper.convertedToDateShort(x.datum)
                      )
                    : x.batchID;
                return {
                    value: x.id,
                    text: tekst,
                    warn: x.waarschuwen
                };
            });

            return tempList;
        },
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        giveBGclass() {
            return this.refreshedTreatment.starttijd != undefined
                ? 'bg-green'
                : ' bg-blue';
        },
        existing() {
            return this.treatmentActivityId > 0;
        },
        visibleMarksFields() {
            const fieldsInit = [
                {
                    key: 'number',
                    label: this.$t('prod_bak', {
                        ns: 'production'
                    }),
                    visible: true
                },
                {
                    key: 'marktype',
                    label: this.$t('com_marktype', {
                        ns: 'common'
                    }),
                    visible: true
                },
                {
                    key: 'startmerk',
                    label: this.$t('prod_startmerk', {
                        ns: 'production'
                    }),
                    visible: true
                },
                {
                    key: 'eindmerk',
                    label: this.$t('prod_eindmerk', {
                        ns: 'production'
                    }),
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return (this.$root as VueExtension).handleFeature(key);
        },
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        showDate(aDate) {
            return DateHelper.convertedToDateShort(aDate);
        },
        setTransfomation(item) {
            this.localChanged = true;
            this.refreshedTreatment.toProductID = item.productID;
            this.refreshedTreatment.multiplier = item.multiplier;
        },
        set_input() {
            this.$emit('change', true);
        },
        async checkReplan() {
            let result = false;
            // voorlopig alleen vandaag afmelden
            const tijd = DateHelper.convertedFromTimepicker(
                this.refreshedTreatment.starttijd ?? new Date(),
                this.uitvoerTijdstip
            );
            this.refreshedTreatment.starttijd = tijd;
            const uren = DateHelper.dateDiffinHours(
                tijd,
                this.treatmentActivity.starttijdplan
            );
            if (Math.abs(uren) > this.maxDelay) {
                const kant =
                    uren < 0
                        ? this.$t('prod_vroeg', {
                              ns: 'production'
                          })
                        : this.$t('prod_laat', {
                              ns: 'production'
                          });
                const message = Helper.stringformat(
                    this.strOpschuiven,
                    Math.abs(Math.round(uren)),
                    kant
                );
                const herplannen = await (
                    this.$root as VueExtension
                ).showConfirmationBox(message);
                if (herplannen) {
                    result = herplannen;
                    this.refreshedTreatment.herplannen = herplannen;
                }
            }
            return result;
        },
        checkProductChange() {
            if (this.canTransform) {
                if (this.transformAsked) return true;
                if (
                    this.refreshedTreatment.toProductID == undefined ||
                    this.refreshedTreatment.product ==
                        this.refreshedTreatment.toProductID
                ) {
                    this.showAlert(this.strNoTransform);
                    this.transformAsked = true;
                    return false;
                }
            }
            return true;
        },
        checkTransform() {
            if (this.transformType < this.transformTypeVersnijden) {
                return this.checkProductChange();
            }
            if (this.transformType == this.transformTypeVersnijden) {
                if (
                    this.refreshedTreatment.multiplier == undefined ||
                    this.refreshedTreatment.multiplier <= 1
                ) {
                    this.showAlert(this.strNoTransformCut);
                    return false;
                }
                this.checkProductChange();
            }
            if (this.transformType == this.transformTypeVerpakken) {
                if (
                    this.refreshedTreatment.multiplier == undefined ||
                    this.refreshedTreatment.multiplier > 1
                ) {
                    this.showAlert(this.strNoTransformPack);
                    return false;
                }
                this.checkProductChange();
            }
            return true;
        },
        set_changed() {
            this.localChanged = true;
        },
        setDatumtijd() {
            if (this.localDate && this.localTijd) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDate,
                    this.localTijd
                );
                this.refreshedTreatment.starttijd = dateTime;
                this.uitvoerTijdstip = DateHelper.convertedToTime(
                    DateHelper.convertedToDateTimeJS(dateTime)
                );
                this.set_changed();
            }
        },
        async loadStockItemList(productID) {
            const selectionData = { productid: productID };
            const locList = await loadItem(
                'stock/loadStockByProduct',
                selectionData,
                this.$t
            );
            this.flexList = locList;
            if (locList.length > 0) {
                this.partijID = locList[0].id;
                if (this.prevPartijID == -1) this.prevPartijID == locList[0].id;
                await this.set_inputPartij();
                this.rerenderkey += 1;
            }
            if (this.itemStockList.length < 1 && !this.existing)
                console.log(
                    this.$t('com_geen_data', {
                        ns: 'common'
                    })
                );
        },
        async set_inputPartij() {
            const stockItem = this.flexList.find((x) => x.id == this.partijID);
            this.warnAmount = stockItem ? stockItem.aantal < 0 : false;
            if (
                this.partijID &&
                this.prevPartijID > -1 &&
                this.partijID != this.prevPartijID
            ) {
                const o = this.flexList.find((x) => x.id == this.prevPartijID);
                const message = Helper.stringformat(
                    this.strStockEmpty,
                    o?.batchID
                );
                const doClose = await (
                    this.$root as VueExtension
                ).showConfirmationBox(message);
                if (doClose) {
                    // zet de voorraad op leeg
                    loadItem(
                        'stock/loadStockItem',
                        {
                            stockitemid: this.prevPartijID
                        },
                        this.$t
                    ).then((x) => {
                        const selectionData = {
                            ID: x.id,
                            LastUpdated: x.gewijzigd,
                            IsEmpty: true,
                            NeverUseAgain: false
                        };
                        loadItem(
                            'stock/closeStockItem',
                            selectionData,
                            this.$t
                        );
                    });
                }
                this.set_changed();
            }
            this.prevPartijID = this.partijID;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            if (this.needsCoatingProduct) {
                if (this.partijID < 0) {
                    if (!this.coatingProductAsked) {
                        this.showAlert(this.strSaveWithoutProduct);
                        this.coatingProductAsked = true;
                        return;
                    }
                }
            }
            if (this.canTransform) {
                const res = this.checkTransform();
                if (!res) return;
            }
            if (this.localChanged) {
                const herplannen = await this.checkReplan();
                this.refreshedTreatment.herplannen = herplannen;
                this.refreshedTreatment.coatingvoorraadID =
                    this.partijID > -1 ? this.partijID : null;

                const selectionData = this.refreshedTreatment.SetForSave();
                const response = await loadItem(
                    'treatment/confirmTreatment',
                    selectionData,
                    this.$t
                );
                this.set_input();
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-confirmdetail');
            });
        },
        giveBakTitle(element) {
            return 'Bak ' + element.number;
        },
        async getData() {
            if (this.treatmentActivityId > -1) {
                this.refreshedMarks = null;
                this.refreshedTreatment = await loadItem(
                    'treatment/loadTreatment',
                    {
                        treatmentActivityID: this.treatmentActivityId
                    },
                    this.$t
                );
                this.refreshedMarks = await loadItem(
                    'stock/loadStockItemMarksBSInfo',
                    {
                        batchgroup: this.refreshedTreatment.batchnummer,
                        productID: this.refreshedTreatment.productID,
                        shapeID: this.refreshedTreatment.vormID
                    },
                    this.$t
                );

                if (
                    this.refreshedTreatment.statusVoorgaande != undefined &&
                    this.refreshedTreatment.statusVoorgaande <
                        window.constants.TAC_DONE
                ) {
                    const message = this.$t('com_voorgaandnogopen', {
                        ns: 'common'
                    });
                    const gaDoor = await (
                        this.$root as VueExtension
                    ).showConfirmationBox(message);
                    if (!gaDoor) {
                        this.$bvModal.hide('modal-confirmdetail');
                    }
                }
            }
        }
    },
    mounted() {},
    async created() {
        const lijst = await loadList(
            'masterdata/getConstantsLijst',
            'masterdata/loadApplicationConstants',
            null,
            this.forceRefresh,
            this.$t
        );
        const locList = await loadList(
            'components/getLocationsComboLijst',
            'components/loadLocationsComboLijst',
            null,
            false,
            this.$t
        );
        const con = lijst
            ? lijst.find(
                  (x) =>
                      x.text == window.constants.APPCONST_ALLOWEDDELAYTREATMENT
              )
            : null;
        this.maxDelay = con ? con.value : 12;
        await this.getData();

        const tempActivity = this.refreshedTreatment; // ?? this.treatmentActivity;
        // zoek toLocatie op, standaard komen we op met de locatie waarvandaan we komen
        const toLocation = locList.find((x) => x.text == this.baseTAC.locatie);
        if (toLocation) {
            this.refreshedTreatment.naarLocatieID = toLocation.value;
        }
        if (tempActivity.coatingproductID) {
            this.needsCoatingProduct = true;
            this.loadStockItemList(tempActivity.coatingproductID);
        }
        if (tempActivity.behandelstapID > window.constants.START_SEQ) {
            const tempList = await loadList(
                'treatment/getTreatmentSteps',
                'treatment/loadTreatmentSteps',
                null,
                false,
                this.$t
            );
            const step = tempList.find(
                (x) => x.id == tempActivity.behandelstapID
            );
            if (step) {
                this.transformType = step.transformtype ?? 0;
                const test = step.transformtype
                    ? step.transformtype > 1
                    : false;
                if (test) {
                    this.transStock = await loadItem(
                        'stock/loadStockItem',
                        { stockitemid: tempActivity.voorraaditemID },
                        this.$t
                    );
                    this.refreshedTreatment.voorraaditem = this.transStock;
                    this.transStock.product = tempActivity.product;

                    this.canTransform = test;
                }
            }
        }
        if (tempActivity.starttijd) {
            this.uitvoerTijdstip = DateHelper.convertedToTime(
                DateHelper.convertedToDateTimeJS(tempActivity.starttijd)
            );
            this.localChanged = false;
        }
        this.localDate = DateHelper.DateForInput(
            tempActivity.starttijd ?? new Date(),
            true,
            false
        );
        this.localTijd = DateHelper.DateForInput(
            tempActivity.starttijd ?? new Date(),
            false,
            true
        );
    }
});
</script>

<style scoped>
.bg-green {
    background-color: #c1e881 !important;
}
.bg-blue {
    background-color: hwb(203 55% 7%) !important;
}
.fontcolor {
    color: red;
}
</style>
